import { Injectable, inject } from '@angular/core';
import { EMPTY, catchError } from 'rxjs';

import { PageService, ServerResponseService } from '@speedy/core';

@Injectable({ providedIn: 'root' })
export class NotFoundResolver {
  private readonly pageService = inject(PageService);
  private readonly serverResponseService = inject(ServerResponseService);

  resolve() {
    return this.pageService.getPage('no-route').pipe(
      catchError(() => {
        this.serverResponseService.setNotFound();
        return EMPTY;
      }),
    );
  }
}
